module.exports = __webpack_public_path__ + "media/images/emblems/La_Chaux-du-Milieu-coat_of_arms-7049c7a0fff3e423c4fc36f63ef92572.svg";